export const getAboutUser = (data: any) => {
  return {
    name: data?.fullName,
    gender: data?.gender,
    bio: data?.bio,
    dateOfBirth: data?.dateOfBirth,
    placeOfBirth: data?.placeOfBirth,
    state: data?.state,
  };
};

export const getEducation = (data: any) => {
  const educations = data?.education?.map((edu: any) => {
    return {
      id: edu?._id,
      institution: edu?.institution,
      degree: edu?.degree,
      startDate: edu?.startDate,
      endDate: edu?.endDate,
    };
  });
  return educations;
};

export const getUserProfile = (data: any) => {
  const profile = {
    profile: data?.profile,
    avatar: data?.avatar,
    fullName: data?.fullname,
    username: data?.username,
    profession: data?.profession,
    follower: data?.followers as any[],
    following: data?.followings as any[],
    friendRequest: data?.friendRequest as any[],
    friends: data?.friends as any[],
    bio: data?.bio,
    posts: data?.post,
    state: data?.state,
    country: data?.country,
  };
  return profile;
};
